module.exports = {
  "country": "DE",
  "artist": "Abor & Tynna",
  "song": "Baller",
  "year": "2025",
  "place": "15",
  "spotify": "4kbkYbhWNiSJraySknB4hD"
};